import SharedAsset from '@zenbusiness/common-components/SharedAsset';

import superstyled from '#client/pages/EducationStudio/utils/superstyled';

export const StyledStandardImage = superstyled({
  tag: SharedAsset,
  styles: {
    width: '100%',
    maxWidth: '40rem',
    marginBottom: '2rem',
    borderStyle: 'solid',
    borderWidth: '1px 5px 5px 1px',
    borderRadius: '1.5rem'
  }
});
